import { Box, Container, Button, useTheme, useMediaQuery } from '@mui/material'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomButton from '../../Components/CustomButton/CustomButton'
import { Input } from '../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../utils/api'
import CreateMyPlantForm from './CreateMyPlantForm'
import EditOperationForm from './EditOperationForm'
import SupprimerOperationForm from './SupprimerOperationForm'
import urls from '../../utils/urls'
// import CreateMyPlantForm from "./CreateMyPlantForm";
import PlantList from './PlantList'
import PlantView from './PlantView'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'

export const Mesplantes = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [infoshow, setInfoShow] = useState(true)

  const [operations, setOperations] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [isAddPlantDialogOpen, setIsAddPlantDialogOpen] = useState(false)
  const [selected, setSelected] = useState(false)
  const [selectedSupprimer, setSelectedSupprimer] = useState(false)

  const [loading, setLoading] = useState(false)

  const { handleSubmit, control } = useForm({
    defaultValues: {
      Nom: '',
      Nombre: '',
      CultureType: '',
      LastWat: '',
      nextWat: '',
      LastFert: '',
      nextFert: '',
      LastRempot: '',
      nextRempot: '',
      Emplacement: '',
    },
  })
  useEffect(() => {
    if (isMobile) {
      setInfoShow(false)
    } else {
      setInfoShow(true)
    }
  }, [isMobile])
  useEffect(() => {
    fetchOperations()
  }, [location.search])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.getMyPlant}?general=true&${location.search.slice(1)}`
    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const filterOperations = (data) => {
    const queryParams = new URLSearchParams(data).toString()
    navigate(`?${queryParams}`)
  }

  const deletePlant = async (plantId) => {
    const response = await makePostRequest(urls.deletePlant.replace(':id', plantId), {}, {}, true)
    if (response.status === 204) {
      const filteredOperations = operations.results.filter((v) => v.id !== plantId)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - 1,
      })
      alert('Plante supprimée avec succès !')
    }
  }
  const deleteBulkDocuments = async () => {
    if (selectedRows.length === 0) {
      alert('Please select document')
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.myPlantsBulkDelete,
        { selected: selectedRows },
        {},
        true,
      )
    }
  }
  return (
    <Box>
      <Box bgcolor={'#001b42'} p={2}>
        <Container maxWidth="xl" sx={{ display: infoshow ? 'block' : 'none' }}>
          <form onSubmit={handleSubmit(filterOperations)}>
            <Box display={'flex'} flexWrap="wrap">
              <Input
                size="small"
                control={control}
                inputProps={{ variant: 'filled', size: 'small' }}
                rules={{ required: false }}
                name="Nom plante"
                label="Nom plante"
              />
              <Input
                size="small"
                control={control}
                inputProps={{
                  variant: 'filled',
                  size: 'small',
                }}
                rules={{ required: false }}
                name="Type de culture"
                label="Type de culture"
              />
              <Input
                size="small"
                control={control}
                inputProps={{
                  variant: 'filled',
                  size: 'small',
                }}
                rules={{ required: false }}
                name="Emplacement"
                label="Emplacement"
              />

              <CustomButton type="submit">Filter</CustomButton>
            </Box>
          </form>
        </Container>
        <Box display={'flex'} justifyContent={'center'} mt={1}>
          {isMobile && (
            <>
              {infoshow ? (
                <KeyboardArrowUpIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              )}
            </>
          )}
        </Box>
      </Box>
      <Container maxWidth="xl" sx={{ pt: 1 }}>
        {isMobile ? (
          <Box display="flex" justifyContent="flex-end" gap={2} color={'white'}>
            <CreateMyPlantForm setOperations={setOperations} />
            <RemoveCircleIcon onClick={deleteBulkDocuments} />
            <EditIcon
              onClick={() => {
                if (selectedRows.length === 1) {
                  setSelectedRowsParams({
                    ...operations.results.filter((v) => v.id === selectedRows[0]),
                  })
                  setSelected(true)
                } else {
                  setSelected(false)
                  alert('Please Select one document for modifier')
                }
              }}
            />
          </Box>
        ) : (
          <Box display="flex" justifyContent="flex-end">
            <CreateMyPlantForm setOperations={setOperations} />
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  setSelectedRowsParams({
                    ...operations.results.filter((v) => v.id === selectedRows[0]),
                  })
                  setSelected(true)
                } else {
                  setSelected(false)
                  alert('Please Select one document for modifier')
                }
              }}
            >
              Modifier
            </CustomButton>

            <CustomButton onClick={deleteBulkDocuments}>Supprimer</CustomButton>
          </Box>
        )}
      </Container>
      <Container maxWidth="xl" sx={{ pt: 1 }}>
        <PlantList
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>

      {selected ? (
        <EditOperationForm
          setOperations={setOperations}
          setSelected={setSelected}
          params={selectedRowsParams}
          operations={operations}
        />
      ) : (
        ''
      )}
    </Box>
  )
}
